
import PRIVILEGE_MAP from './privilege';
const { MALL, ACCOUNT, BUSINESS, SETTLE } = PRIVILEGE_MAP;
/*
 * 模拟菜单，整个左侧导航栏的配置都在这,dataType字段与functions中的目录同名代表一个module
 * -- name：模块名称
 * -- dataType: 模块标识
 * -- isModule: 是否为路由模块
 * -- dtos: 子级
 *
 * shopTypeNo: 指定类型店铺有权查看, 1496903047847727111 - 食堂类型
 * shopUserRole: 指定角色有权查看，1-管理店铺 2-服务店铺 3-配送店铺 4-工作店铺
 * 若无shopTypeNo且为shopUserRole限制的，则为公开路由
 *
 * @Author: fan.li@zuolin.com
 * @Date: 2019-07-30 15:42:05
 * @Last Modified by: fan.li@zuolin.com
 *
 */

const mockMenu = [
	// {
	// 	name: '商城首页',
	// 	dataType: 'trade-dashboard',
	// 	isModule: true,
	// 	privilegeId: MALL.MALL_TRADE_OVERVIEW,
	// },
	{
		name: '店铺管理',
		dataType: 'shop-approve',
		isModule: false,
		dtos: [
			{
				name: '店铺列表',
				dataType: 'shop-approve',
				isModule: true,
				privilegeId: MALL.MALL_STORE_VIEW,
			},
			// {
			// 	name: '运营配置',
			// 	dataType: 'orders-manage',
			// 	isModule: true,
			// 	privilegeId: MALL.MALL_CHANGE_STORE_ADMINISTRATOR,
			// },
		],
	},
	{
		name: '订单管理',
		dataType: 'order-management',
		isModule: false,
		dtos: [
			{
				name: '交易记录',
				dataType: 'mall-order',
				isModule: true,
				privilegeId: MALL.MALL_ORDER_VIEW,
			}
		]
	},
	{
		name: '财务管理',
		dataType: 'settlement-manage',
		isModule: false,
		// privilegeId: 9999990001004,
		dtos: [
			{
				name: '商户主页',
				dataType: 'merchant-home',
				isModule: true,
				privilegeId: ACCOUNT.ACCOUNT_HOMEPAGE_OVERVIEW,
			},
			{
				name: '账务明细',
				dataType: 'financial-details',
				isModule: true,
				merchantStatus: [2],
				privilegeId: ACCOUNT.FINANCE_DETAIL_OVERVIEW,
			},
			{
				name: '交易查询',
				dataType: 'trade-inquiries',
				isModule: true,
				merchantStatus: [2],
				privilegeId: ACCOUNT.TRADE_DETAIL_OVERVIEW
			},
			// {
			// 	name: '对账单',
			// 	dataType: 'mall-bill',
			// 	isModule: true,
			// 	privilegeId: SETTLE.MALL_SETTLE_MERCHANT_BILL_VIEW,
			// },
			{
				name: '对账结算',
				dataType: 'mall-settlement',
				isModule: true,
				privilegeId: SETTLE.MALL_SETTLE_MERCHANT_BILL_VIEW,
			},
			{
				name: '营收统计',
				dataType: 'revenue-analysis',
				isModule: true,
			}
			// {
			// 	name: '企业消费汇总',
			// 	dataType: 'enterprise-consumption-summary',
			// 	isModule: true,
			// }
		]
	},
	{
		name: '营销活动',
		dataType: 'marketing-activity',
		isModule: false,
		merchantStatus: [2],
		dtos: [
			{
				name: '活动促销',
				dataType: 'activity-promotion',
				isModule: true,
				merchantStatus: [2],
				privilegeId: BUSINESS.BUSINESS_ACTIVITY_OVERVIEW
			},
			{
				name: '卡券促销',
				dataType: 'cardcoupon-promotion',
				isModule: true,
				merchantStatus: [2],
				privilegeId: BUSINESS.BUSINESS_COUPON_OVERVIEW
			}
		]
	},
	{
		name: '员工管理',
		dataType: 'staff-manage',
		isModule: false,
		privilegeId: MALL.MALL_USER_MANAGEMENT,
		dtos: [
			{
				name: '岗位管理',
				dataType: 'mall-job',
				isModule: true,
			},
			{
				name: '账号管理',
				dataType: 'mall-staff',
				isModule: true,
			},
		]
	},
	{
		name: '商城设置',
		dataType: 'mall-setting',
		isModule: false,
		dtos: [
			{
				name: '基础信息',
				dataType: 'mall-setting',
				isModule: true,
				privilegeId: MALL.MALL_VIEW
			}
		]
	}
];

export default mockMenu;
